import { gql } from '@apollo/client';

/**
 * 二次建联（电联2）。对应 api-server PickupSecondContactMutation.submitSecondContact。
 * contacted=true → 补群转已建联(link_status 4)；contacted=false → 确认无法建联(link_status 5，仅揽收失败态可达)。
 */
export const SUBMIT_SECOND_CONTACT = gql`
  mutation SubmitSecondContact($input: SecondContactInput!) {
    submitSecondContact(input: $input)
  }
`;

export interface SecondContactInput {
  cooperationWarehouseId: number;
  contacted: boolean;
  groupId?: string | null;
  groupName?: string | null;
  groupQrcodeS3Key?: string | null;
  /** 未联系到的联络记录截图 S3 key JSON（可空） */
  proofS3KeysJson?: string | null;
}

export interface SubmitSecondContactResponse {
  submitSecondContact: boolean;
}
